import { Info } from 'lucide-react';

import { cn } from '@/lib/utils/cn';
import { useSettingsStore } from '@/store';

export default function MaintenanceBanner() {
  const { settings } = useSettingsStore();
  return (
    <div
      className={cn(
        'w-full flex items-center justify-center gap-3 py-3 px-4 text-sm border-b mt-16',
        'bg-amber-100 text-amber-900 border-amber-200',
        'dark:bg-amber-950/50 dark:text-amber-200 dark:border-amber-800/50',
        'transition-colors duration-200'
      )}
    >
      <div className="sm:container w-full flex items-center justify-center gap-2 px-4 md:px-6">
        <Info size={18} className="shrink-0" aria-hidden="true" />
        <p className="font-medium">
          {settings.ui?.maintenance?.message ||
            "We're currently performing maintenance"}
        </p>
      </div>
    </div>
  );
}
